export default __webpack_public_path__ + "static/media/incapacities.a6c86ea2.svg";